<template>
  <div>
    <v-card v-if="instrumenAwal.length" class="mx-auto mb-6" flat>
      <v-card-text>
        <v-row>
          <v-col v-for="(sch, id) in instrumenAwal" :key="id" cols="12" sm="12" :md="sch.grid || 12">
            <div class="mx-3 black--text" v-if="sch.title">
              <span v-html="sch.title"></span>
              <v-divider class="primary" style="height: 2.5px; max-height: 2.5px" />
            </div>
            <div class="mx-3 black--text" v-if="sch.subtitle">
              <span v-html="sch.subtitle"></span>
            </div>
            <div>
              <base-form-generator :schema="sch.instrumen" v-model="form" class="pt-5 px-3" />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-show="instrumenLanjutan.length" class="mx-auto" flat>
      <v-card-text>
        <v-alert dense text type="info" class="mx-2 mt-3">
          <div class="black--text">
            <h4>Informasi Pengisian</h4>
            <ol class="mt-1" style="padding-inline-start: 18px">
              <li>Semua data di bawah ini <strong>wajib</strong> diisi</li>
              <li>
                Anda dapat melakukan pengisian secara bertahap sampai status laporan berubah menjadi
                <strong>dilengkapi</strong>
              </li>
            </ol>
          </div>
        </v-alert>
        <v-row>
          <template v-for="(sch, id) in instrumenLanjutan">
            <v-col v-if="!sch.hidden" :key="id" cols="12" sm="12" :md="sch.grid || 12">
              <div class="mx-3 black--text" v-if="sch.title">
                <span v-html="sch.title"></span>
                <v-divider class="primary" style="height: 2.5px; max-height: 2.5px" />
              </div>
              <div :class="['mx-3 black--text', sch.subtitleClass]" v-if="sch.subtitle">
                <span v-html="sch.subtitle"></span>
              </div>
              <div v-if="sch.type && sch.type === 'File'">
                <form class="pt-3 px-3">
                  <v-row>
                    <template v-for="(file, idFile) in sch.instrumen">
                      <v-col cols="12" :key="idFile">
                        <div v-if="!berkases[file.id]">
                          <span class="grey--text">{{ file.label }} *</span>
                          <v-file-input
                            v-model="form[file.name]"
                            :accept="$getDeepObj(configBerkas, `${file.name}.accept`) || ['image/*']"
                            :error-messages="getErrorMsg(file.name)"
                            outlined
                            dense
                            :hide-details="!getErrorMsg(file.name)"
                            prepend-icon=""
                            @click:append="handleClickAppend(idFile)"
                            :ref="`vFileInput_${idFile}`"
                            append-icon="mdi-paperclip"
                            :placeholder="`Unggah ${file.label || ''}`"
                          />
                        </div>
                        <div v-else>
                          <span class="grey--text">{{ file.label }} *</span>
                          <div>
                            <v-btn
                              depressed
                              color="success"
                              class="white--text mr-2"
                              :href="berkases[file.id]"
                              target="_blank"
                            >
                              Lihat Berkas
                              <v-icon right dark>
                                mdi-link
                              </v-icon>
                            </v-btn>
                            <v-btn outlined color="blue-grey" class="white--text" @click="onChangeBerkas(file)">
                              Ganti Berkas
                              <v-icon right dark>
                                mdi-pencil
                              </v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </form>
              </div>
              <div v-else-if="sch.type && sch.type === 'rekapitulasi'">
                <template v-for="(rekap, r) in sch.rekaps">
                  <div class="container my-2" :key="r">
                    <div class="body-1 font-weight-medium mb-2">{{ rekap.label }}</div>
                    <v-card outlined>
                      <v-card-text>
                        <div v-for="(child, c) in rekap.children" :key="c">
                          <div
                            :class="['info--text body-1 font-weight-medium mb-4', c > 0 ? 'mt-6' : '']"
                            v-html="child.label"
                          ></div>
                          <v-row
                            class="grey--text text--darken-2 body-2"
                            v-for="(kMonevFeedback, idQuestion) in Object.keys(child.questions)"
                            :key="`${r}-${c}-${idQuestion}`"
                          >
                            <v-col v-if="idQuestion !== 0" cols="12" class="pb-0">
                              <v-divider />
                            </v-col>
                            <v-col cols="12" sm="12" md="5" class="my-auto">
                              <v-row no-gutters style="flex-wrap: nowrap">
                                <v-col
                                  cols="1"
                                  class="flex-grow-0 flex-shrink-1"
                                  style="min-width: 15px; max-width: 25px !important;"
                                >
                                  {{ idQuestion + 1 }}.
                                </v-col>
                                <v-col cols="11" class="flex-grow-0 flex-shrink-1">
                                  {{ child.questions[kMonevFeedback] }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="7" class="pa-0">
                              <base-form-generator
                                :schema="mOpsiFeedback[kMonevFeedback]"
                                v-model="feedback[kMonevFeedback]"
                                class="pt-5 px-3"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </template>
              </div>
              <div v-else-if="sch.type && sch.type === 'peserta'">
                <form-peserta :detail="detail" v-model="form['peserta']" />
              </div>
              <div v-else-if="sch.type && sch.type === 'rekaman'" class="mt-5 px-3">
                <template v-for="(meeting, m) in form.data_meeting">
                  <v-row :key="m" no-gutters>
                    <v-col cols="12" md="9" sm="12">
                      <base-form-generator
                        :key="m"
                        :schema="schemaMeetings"
                        v-model="form.data_meeting[m]"
                        @input="getDurasi(form.data_meeting[m], m)"
                      />
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <div class="mt-5 ml-2">
                        <v-btn
                          v-if="!readOnly && (form.data_meeting || []).length > sch.min"
                          class="mt-n2"
                          color="error"
                          depressed
                          @click="onDelRekaman(m)"
                        >
                          <v-icon left>mdi-delete</v-icon> Hapus
                        </v-btn>
                        <span class="blue--text pa-3">
                          {{ (durasis && durasis[Number(m)]) || '' }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <v-btn
                  v-if="!readOnly && sch.hideOnMax && (form.data_meeting || []).length < sch.max"
                  @click="onAddRekaman"
                  color="primary"
                  depressed
                  :disabled="sch.hideOnMax && (form.data_meeting || []).length >= sch.max"
                >
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Tambah Tautan Rekaman
                </v-btn>
              </div>
              <div v-else-if="sch.type && sch.type === 'berkas'" class="mt-3 px-3">
                <v-alert v-if="sch.min > 1" dense text type="info" class="mt-3 mb-1">
                  <div class="black--text">
                    Lengkapi Berkas {{ sch.label }} dengan minimal {{ sch.min }} berkas dan maksimal
                    {{ sch.max }} berkas
                  </div>
                </v-alert>
                <div
                  v-for="(berkas, idBerkas) in (form.berkases && form.berkases[sch.k_monev_berkas_psp]) || []"
                  :key="`${sch.k_monev_berkas_psp}-${idBerkas}`"
                >
                  <validation-provider
                    :key="`${sch.k_monev_berkas_psp}-${idBerkas}`"
                    mode="passive"
                    name="Tautan / link / url"
                    v-slot="{ errors }"
                  >
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <span class="px-0 body-2 grey--text" style="height: 24px;">
                          Pilih Dokumentasi {{ idBerkas + 1 }} <span class="red--text"> * </span>
                        </span>
                        <v-text-field
                          v-if="!$getDeepObj(form.berkases, `${sch.k_monev_berkas_psp}.${idBerkas}.file_berkas`)"
                          placeholder="Pilih gambar / dokumen yang ingin diunggah"
                          outlined
                          dense
                          singleLine
                          disabled
                          :error-messages="errors"
                          hide-details
                        />
                        <div v-else :class="['black--text', 'grey lighten-3 pa-3']" style="border-radius: 5px">
                          <a
                            :href="$getDeepObj(form.berkases, `${sch.k_monev_berkas_psp}.${idBerkas}.url_berkas`)"
                            target="_blank"
                          >
                            Lihat Berkas Dokumentasi {{ idBerkas + 1 }}
                          </a>
                        </div>
                      </v-list-item-content>
                      <v-list-item-action v-if="!readOnly" class="my-auto">
                        <v-list-item-action-text>
                          <div class="white--text mb-1">Aksi</div>
                          <v-btn depressed color="success" @click="onUploadBerkas(sch, idBerkas)">
                            {{
                              $getDeepObj(form.berkases, `${sch.k_monev_berkas_psp}.${idBerkas}.file_berkas`)
                                ? 'Ubah'
                                : 'Unggah'
                            }}
                          </v-btn>
                          <v-btn
                            v-if="form.berkases[sch.k_monev_berkas_psp].length > sch.min"
                            depressed
                            color="error"
                            class="ml-1"
                            @click="onDelBerkas(sch, idBerkas)"
                          >
                            Hapus
                          </v-btn>
                        </v-list-item-action-text>
                      </v-list-item-action>
                    </v-list-item>
                  </validation-provider>
                </div>
                <div v-if="!readOnly && sch.min < sch.max">
                  <v-btn
                    color="primary"
                    class="text-capitalize"
                    depressed
                    :disabled="id + 1 >= sch.max"
                    @click="onAddBerkas(sch)"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Tambah Berkas
                  </v-btn>
                </div>
              </div>
              <div v-else-if="sch.type && sch.type === 'checkbox'">
                <v-row>
                  <v-col v-for="(option, optionId) of sch.options" :key="optionId" cols="12" lg="1">
                    {{ option }}
                  </v-col>
                </v-row>
              </div>
              <div v-else-if="sch.type === 'link'" class="px-3">
                <v-row>
                  <v-col
                    v-for="(link, linkId) of sch.instrumen"
                    :key="`${id}-link-${linkId}`"
                    cols="12"
                    :lg="link.size"
                  >
                    <v-alert text :color="link.color">
                      <div v-html="link.content"></div>
                    </v-alert>
                  </v-col>
                </v-row>
              </div>
              <div v-else-if="sch.children">
                <v-row>
                  <template v-for="(child, idChild) in sch.children">
                    <v-col :key="idChild" cols="12" sm="12" :md="child.grid || 12">
                      <div v-if="child.label" class="pt-3 px-3">
                        <span class="px-0 body-2 grey--text" style="height: 24px">
                          <span v-html="child.label" />
                        </span>
                      </div>
                      <template v-for="(ins, i) in child.instrumen">
                        <div :key="i" v-if="ins.type === 'Checkbox'">
                          <v-checkbox
                            v-model="form[ins.name]"
                            :label="ins.label"
                            :value="ins.value"
                            :disabled="
                              (form['opsi-psp_7_8'] && ins.name !== 'opsi-psp_7_8' && idChild === 0) ||
                                (form['opsi-psp_8_13'] && ins.name !== 'opsi-psp_8_13' && idChild === 1) ||
                                ins.disabled
                            "
                            class="mx-2 my-0"
                            hide-details
                            @change="onChangeOpsi(child, ins.name)"
                          />
                        </div>
                        <div :key="i" v-else>
                          <base-form-generator :schema="child.instrumen" v-model="form" class="px-3" />
                        </div>
                      </template>
                      <div
                        class="mx-3"
                        v-show="(form['opsi-psp_7_9'] && idChild === 0) || (form['opsi-psp_8_14'] && idChild === 1)"
                      >
                        <v-text-field
                          v-model="form[`${idChild === 0 ? 'opsi-psp_7_9' : 'opsi-psp_8_14'}_catatan`]"
                          placeholder="Tuliskan keterangan lainnya"
                          class="pt-0"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </template>
                </v-row>
              </div>
              <div v-else>
                <base-form-generator :schema="sch.instrumen" v-model="form" class="pt-5 px-3" />
              </div>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
    <base-modal-full ref="upload" generalError :title="formulir.title" @save="onUploadSave">
      <form-unggah
        ref="formulir"
        :title="formulir.title"
        :format="formulir.format"
        :rules="formulir.rules || {}"
        mode="upload"
        uimodel="card"
        :use-header="false"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
import Instrumen from './instrumen';
import FormPeserta from './formulir/Peserta';
import FormUnggah from '@components/form/Unggah';
import { mapActions } from 'vuex';

export default {
  name: 'FormLaporanIht',
  components: { ValidationProvider, BaseFormGenerator, FormPeserta, FormUnggah },
  mixins: [Instrumen],
  props: {
    id: {
      default: null,
    },
    childId: {
      default: null,
    },
    type: {
      default: null,
    },
    masters: {
      type: Object,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    },
    kasek: {
      type: Object,
      default: null,
    },
    mapels: {
      type: [Object, Array],
      default: () => {},
    },
    initValue: {
      type: Object,
      default: null,
    },
    meta: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configBerkas: {
        file_dok1: { accept: ['image/*'], min: 20, max: 1536 },
        file_dok2: { accept: ['image/*'], min: 20, max: 1536 },
        file_dok3: { accept: ['image/*'], min: 20, max: 1536 },
        file_presensi: { accept: ['image/*', '.pdf'], min: 20, max: 1536 },
        file_konsumsi: { accept: ['image/*', '.pdf'], min: 20, max: 1536 },
      },
      berkases: {},
      form: {},
      formulir: {},
      feedback: {},
      durasis: [],
      idQuestion: 0,
    };
  },
  computed: {
    instrumen() {
      const schema = this.schema[this.id];
      return this.$isObject(schema) ? schema[this.childId || 0] : schema;
    },

    instrumenAwal() {
      return this.instrumen.filter((ins) => ins.jenis_instrumen === 'awal');
    },

    instrumenLanjutan() {
      return this.instrumen.filter((ins) => ins.jenis_instrumen !== 'awal');
    },

    instrumenFeedback() {
      return this.instrumen.filter((ins) => ins.type === 'rekapitulasi');
    },

    mOpsiFeedback() {
      let result = {};

      for (const ins of this.instrumenFeedback) {
        for (const rekap of ins.rekaps) {
          for (const child of rekap.children) {
            for (const kMonevFeedback in child.questions) {
              const pspMonevfb = (this.$getDeepObj(this.detail, 'psp_monev_feedbacks') || []).length;
              const n1 = this.feedback[kMonevFeedback] && this.feedback[kMonevFeedback]['n1'];
              const n2 = this.feedback[kMonevFeedback] && this.feedback[kMonevFeedback]['n2'];
              const n3 = this.feedback[kMonevFeedback] && this.feedback[kMonevFeedback]['n3'];
              const n4 = this.feedback[kMonevFeedback] && this.feedback[kMonevFeedback]['n4'];

              result[kMonevFeedback] = [
                {
                  type: 'VTextField',
                  name: 'n1',
                  label: 'Sangat Tidak Setuju',
                  labelColor: 'red',
                  backgroundColor: pspMonevfb && !n1 && n1 !== 0 ? 'red lighten-5' : '',
                  placholder: 'Tuliskan angka',
                  grid: { cols: 12, sm: 12, md: 3 },
                  mask: '######',
                  outlined: true,
                  dense: true,
                  singleLine: true,
                  hideDetails: true,
                },
                {
                  type: 'VTextField',
                  name: 'n2',
                  label: 'Tidak Setuju',
                  labelColor: 'warning',
                  backgroundColor: pspMonevfb && !n2 && n2 !== 0 ? 'red lighten-5' : '',
                  placholder: 'Tuliskan angka',
                  grid: { cols: 12, sm: 12, md: 3 },
                  mask: '######',
                  outlined: true,
                  dense: true,
                  singleLine: true,
                },
                {
                  type: 'VTextField',
                  name: 'n3',
                  label: 'Setuju',
                  labelColor: 'blue',
                  backgroundColor: pspMonevfb && !n3 && n3 !== 0 ? 'red lighten-5' : '',
                  placholder: 'Tuliskan angka',
                  grid: { cols: 12, sm: 12, md: 3 },
                  mask: '######',
                  outlined: true,
                  dense: true,
                  singleLine: true,
                },
                {
                  type: 'VTextField',
                  name: 'n4',
                  label: 'Sangat Setuju',
                  labelColor: 'green',
                  backgroundColor: pspMonevfb && !n4 && n4 !== 0 ? 'red lighten-5' : '',
                  placholder: 'Tuliskan angka',
                  grid: { cols: 12, sm: 12, md: 3 },
                  mask: '######',
                  outlined: true,
                  dense: true,
                  singleLine: true,
                },
              ];
            }
          }
        }
      }

      return result;
    },

    isKejuruan() {
      const sekolah = this.$getDeepObj(this.kasek, 'sekolah') || {};
      return Number(sekolah.k_jenjang) === 5;
    },

    isSmkPk() {
      const diklatSekolah = this.$getDeepObj(this.meta, 'pelaksana_aktif') || {};
      return Number(this.$getDeepObj(diklatSekolah, 'sekolah.k_jenjang')) === 5;
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('iht', ['uploadBerkas']),

    reset() {
      let feedback = {};
      const intrumens = this.instrumen.filter((ins) => ins.type === 'rekapitulasi');
      for (const instrumen of intrumens) {
        for (const rekap of instrumen.rekaps) {
          for (const child of rekap.children) {
            for (const kMonevFeedback in child.questions) {
              feedback[kMonevFeedback] = {};
            }
          }
        }
      }

      this.$set(this, 'berkases', {});
      this.$set(this, 'form', {});
      this.$set(this, 'feedback', feedback);
    },

    resetRekaman() {
      this.$set(this.form, 'data_meeting', []);
      this.durasis = [];

      // set init rekaman
      const instrumensRekaman = this.instrumen.filter((ins) => ins.type === 'rekaman');
      const instrumenRekaman = instrumensRekaman[0] || {};
      const meetings = this.$getDeepObj(this.detail, 'data_meeting') || [];

      for (let i = 0; i < instrumenRekaman.max; i++) {
        if (meetings[i]) {
          this.form.data_meeting.push({ url_meeting: meetings[i] && meetings[i]['url_meeting'] });
          this.durasis[i] = this.$durasiWaktu(meetings[i]['durasi'] || null);
        } else {
          this.form.data_meeting.push({ url_meeting: '' });
        }
      }
    },

    resetBerkas() {
      this.$set(this.form, 'berkases', {});

      // set init berkas
      const instrumensBerkases = this.instrumen.filter((ins) => ins.type === 'berkas');
      for (const instrumenBerkas of instrumensBerkases) {
        this.$set(this.form.berkases, instrumenBerkas.k_monev_berkas_psp, []);

        for (let i = 0; i < instrumenBerkas.min; i++) {
          this.form.berkases[instrumenBerkas.k_monev_berkas_psp].push({
            label: instrumenBerkas.key,
            k_monev_berkas_psp: instrumenBerkas.k_monev_berkas_psp,
            file_berkas: '',
          });
        }

        // update init data
        const pspMonevBerkases = (this.detail.psp_monev_berkases || []).filter(
          (berkas) => +berkas.k_monev_berkas_psp === +instrumenBerkas.k_monev_berkas_psp
        );
        for (const id in pspMonevBerkases) {
          const berkas = pspMonevBerkases[id] || {};

          if (this.form.berkases[instrumenBerkas.k_monev_berkas_psp][id]) {
            this.form.berkases[instrumenBerkas.k_monev_berkas_psp][id] = {
              label: instrumenBerkas.key,
              k_monev_berkas_psp: berkas.k_monev_berkas_psp,
              file_berkas: berkas.file_berkas,
              url_berkas: berkas.url_berkas,
            };
          } else {
            this.form.berkases[instrumenBerkas.k_monev_berkas_psp].push({
              label: instrumenBerkas.key,
              k_monev_berkas_psp: berkas.k_monev_berkas_psp,
              file_berkas: berkas.file_berkas,
              url_berkas: berkas.url_berkas,
            });
          }
        }
      }
    },

    handleClickAppend(idFile) {
      this.$refs[`vFileInput_${idFile}`][0].$el.querySelector('input').click();
    },

    initForm(value) {
      this.reset();

      // set berkases
      // const berkases = this.$getDeepObj(this.detail, 'psp_monev_berkases') || [];
      // for (const berkas of berkases) {
      //   this.$set(this.berkases, berkas.k_monev_berkas_psp, berkas.url_berkas);
      // }

      // set feedbacks
      const feedbacks = this.$getDeepObj(this.detail, 'psp_monev_feedbacks') || [];
      let mapFeedbacks = this.$arrToObj(feedbacks, 'k_monev_feedback_psp') || {};
      for (const kMonevFeedback in this.feedback) {
        let values = {};
        for (let i = 1; i <= 4; i++) {
          const monevFeedback = mapFeedbacks[kMonevFeedback] || {};
          if (!monevFeedback[`n${i}`] && monevFeedback[`n${i}`] !== 0) {
            values[`n${i}`] = '';
          } else {
            values[`n${i}`] = monevFeedback[`n${i}`];
          }
        }

        this.feedback[kMonevFeedback] = Object.assign({}, values);
      }

      // update
      for (const sch of this.instrumen) {
        for (const instrumen of sch.instrumen || []) {
          if (!['File', 'textView', 'link'].includes(instrumen.type)) {
            const val = value && value[instrumen.name];
            this.$set(this.form, instrumen.name, val !== null && val !== undefined ? val : null);
          }
        }
      }

      //update rekap guru
      for (const mapelId in this.$getDeepObj(value, 'rekap_guru') || {}) {
        const rekap = this.$getDeepObj(value, `rekap_guru.${mapelId}`) || {};
        this.$set(this.form, `mapel-${mapelId}`, rekap.jumlah);
      }

      // set init instrumens
      for (const instrumen of this.$getDeepObj(value, 'psp_monev_instrumens') || []) {
        if (instrumen.k_monev_opsi_psp) {
          this.$set(
            this.form,
            `opsi-psp_${instrumen.k_monev_instrumen_psp}_${instrumen.k_monev_opsi_psp}`,
            instrumen.k_monev_opsi_psp
          );

          if ([9, 14].includes(+instrumen.k_monev_opsi_psp)) {
            this.$set(
              this.form,
              `opsi-psp_${instrumen.k_monev_instrumen_psp}_${instrumen.k_monev_opsi_psp}_catatan`,
              instrumen.catatan || ''
            );
          }
        } else {
          this.$set(this.form, `instrumen-psp_${instrumen.k_monev_instrumen_psp}`, instrumen.catatan || '');
        }
      }

      // set or overide
      this.$set(this.form, 'k_monev_laporan_psp', this.id);
      this.$set(this.form, 'nama', this.$getDeepObj(this.detail, 'ptk.nama') || '');
      this.$set(this.form, 'sekolah', this.$getDeepObj(this.detail, 'kasek.sekolah.nama') || '');
      this.$set(this.form, 'kota', this.$getDeepObj(this.detail, 'kasek.sekolah.m_kota.keterangan') || '');
      if (this.$isObject(value)) {
        this.$set(this.form, 'is_terlaksana', value.is_terlaksana === null ? '' : value.is_terlaksana.toString());
        this.$set(this.form, 'is_luar_hadir', !!value.nama_hadir_lain || !!value.jml_hadir_lain ? '1' : '0');
      }

      // Set form child
      // if (this.childId && (this.instrumen || []).filter((question) => question.type === 'rekapitulasi').length > 0) {
      //
      //   this.$set(this.form, 'feedback', feedbacks);
      //   this.$set(
      //     this.form,
      //     'peserta',
      //     pesertas.map((item) => {
      //       return {
      //         ptk_id: item.ptk_id,
      //         n_pretest: item.n_pretest,
      //         n_posttest: item.n_posttest,
      //       };
      //     })
      //   );
      // }
    },

    getValue() {
      let id = 0;
      let form = Object.assign({ instrumens: [] }, this.form);

      if (this.isSmkPk) {
        form['is_terlaksana'] = 1;
      }

      for (const key in form) {
        if (/instrumen-psp/.test(key)) {
          const instrumen = key.split('_');

          if (form[key]) {
            form.instrumens.push({
              k_monev_instrumen_psp: instrumen[1] || '',
              catatan: form[key] || '',
            });
            // form[`instrumens[${id}][k_monev_instrumen_psp]`] = instrumen[1] || '';
            // form[`instrumens[${id}][catatan]`] = form[key] || '';
            // id += 1;
          }

          delete form[key];
        } else if (/opsi-psp/.test(key) && !/catatan/.test(key)) {
          const opsi = key.split('_');

          if (form[key]) {
            form.instrumens.push({
              k_monev_instrumen_psp: opsi[1] || '',
              k_monev_opsi_psp: form[key] || '',
              catatan: form[`${key}_catatan`] || '',
            });
            // form[`instrumens[${id}][k_monev_instrumen_psp]`] = opsi[1] || '';
            // form[`instrumens[${id}][k_monev_opsi_psp]`] = form[key] || '';
            // form[`instrumens[${id}][catatan]`] = form[`${key}_catatan`] || '';
            // id += 1;
          }

          delete form[key];
          delete form[`${key}_catatan`];
        } else if (/mapel-/.test(key)) {
          if (+form['is_terlaksana'] === 1) {
            const mapel = key.split('-');

            if (form[key] && form[key] !== null) {
              form[`rekap_guru[${id}][mapel_id]`] = mapel[1] || '';
              form[`rekap_guru[${id}][jml_guru]`] = form[key] || '';
            }

            id += 1;
          }

          delete form[key];
        }
      }

      // update param meeting
      const meetings = (form.data_meeting || []).filter((meet) => !!meet.url_meeting);
      if (!meetings.length) {
        form['data_meeting'] = null;
      }

      // update param berkas
      let berkases = [];
      for (const kBerkas of Object.keys(form.berkases || {})) {
        berkases = [...berkases, ...(form.berkases[kBerkas] || [])];
      }
      form.berkases = berkases;

      return {
        id: this.$getDeepObj(this.detail, 'psp_monev_id') || '',
        params: form,
        feedback: this.feedback,
      };
    },

    getErrorMsg(fileName) {
      if (!this.form[fileName]) {
        return;
      }

      const file = this.form[fileName] || {};
      const fileSize = file.size / 1000;
      const min = this.$getDeepObj(this.configBerkas, `${fileName}.min`);
      const max = this.$getDeepObj(this.configBerkas, `${fileName}.max`);

      if (min && max && (fileSize < min || fileSize > max)) {
        return 'Berkas yang diunggah harus berukuran antara 20KB - 1.5MB';
      }

      return '';
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;

      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },

    onChangeBerkas(file) {
      this.$set(this.berkases, file.id, null);
      this.$set(this.form, file.name, null);
    },

    onChangeOpsi(child, name) {
      if (this.form[name]) {
        if (['opsi-psp_7_8', 'opsi-psp_8_13'].includes(name)) {
          for (const ins of child.instrumen || []) {
            if (ins.name !== name) {
              this.$set(this.form, ins.name, '');
            }
          }
        } else if (['opsi-psp_7_8', 'opsi-psp_8_13'].includes(name)) {
          this.$set(this.form, `${name}_catatan`, null);
        }
      }
    },

    onChangePelaksanaan() {
      this.resetBerkas();
    },

    onChangeModa() {
      this.resetRekaman();
    },

    onAddRekaman() {
      this.form.data_meeting.push({ url_meeting: '' });
    },

    onDelRekaman(index) {
      this.form.data_meeting.splice(index, 1);
      this.$delete(this.durasis, index);
    },

    onAddBerkas(config) {
      this.form.berkases[config.k_monev_berkas_psp].push({
        k_monev_berkas_psp: config.k_monev_berkas_psp,
        label: config.key,
        file_berkas: '',
      });
    },

    onDelBerkas(config, id) {
      this.form.berkases[config.k_monev_berkas_psp].splice(id, 1);
    },

    onUploadBerkas(config, id) {
      let rules = { format: 'JPG/ JPEG', required: true };
      if (['presensi', 'konsumsi'].includes(config.key)) {
        rules = { format: 'JPG/JPEG/PDF', required: true };
      }

      this.$set(this, 'formulir', {});
      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'title', `Unggah ${config.label}`);
      this.$set(this.formulir, 'format', `harus bertipe ${this.$getDeepObj(rules, `format`)}`);
      this.$set(this.formulir, 'rules', rules);
      this.$set(this.formulir, 'k_monev_berkas_psp', config.k_monev_berkas_psp);
      this.$set(this.formulir, 'key', config.key);
      this.$refs.upload.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onUploadSave() {
      const id = this.formulir.id;
      const key = this.formulir.key;
      const kMonevBerkas = this.formulir.k_monev_berkas_psp;
      const params = new FormData();
      params.append('label', key);
      params.append('file', this.$refs.formulir.form.file);

      this.uploadBerkas({ params })
        .then(({ data }) => {
          this.$set(this.form.berkases[kMonevBerkas], id, {
            k_monev_berkas_psp: kMonevBerkas,
            file_berkas: data.berkas,
            url_berkas: data.url,
          });
          this.$refs.upload.close();
        })
        .catch(() => {
          this.$refs.upload.loading = false;
        });
    },
  },
  watch: {
    initValue: 'initForm',
    'form.is_terlaksana': 'onChangePelaksanaan',
    'form.k_monev_moda_psp': 'onChangeModa',
  },
};
</script>

<style scoped></style>
